<script lang="ts">
	import { twMerge } from "tailwind-merge";
	import type { ComponentEditingProps } from "#lib/components/page/ComponentProps.js";
	import EditorInset from "#lib/components/page/editing/EditorInset.svelte";
	import { stringValue, structValue } from "#lib/struct.js";

	let { id, page, children }: ComponentEditingProps = $props();

	const direction = $derived(stringValue(structValue($page.config, id), "direction"));
	const className = $derived(stringValue(structValue($page.config, id), "class"));
</script>

<EditorInset>
	<div class={twMerge(`flex w-full min-w-0 flex-${direction === "col" ? "row" : "col"}`, className)} class:gap-4={direction === "row"} class:gap-8={direction === "col"}>
		{@render children?.()}
	</div>
</EditorInset>
